import { reskinStyles, THEME_VARIANTS } from 'core/components/theme/theme-variant';

/**
 * Shared styles for the FO-41 toggle section and resident info banner,
 * used by both the add form and the edit (person) form.
 */
export const farmInterestedPartyStyles = (theme) => ({
  fo41Container: {
    border: `2px solid ${theme.colorPalette.white}`,
    borderRadius: theme.sizes.roundCorners,
    width: '100%',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    // Reskin: a beige inset panel; a white border can't frame anything on the new look's white card.
    ...reskinStyles(theme, theme.cardStyles.inset),
    // Classic only: the new look's toggle already shows its off thumb on the light card.
    ...(theme.themeVariant !== THEME_VARIANTS.RESKIN && {
      '& .MuiSwitch-colorPrimary:not(.Mui-checked) .MuiSwitch-thumb': {
        backgroundColor: theme.colorPalette.beige_75
      }
    })
  },
  fo41Description: {
    marginBottom: `${theme.spacing(2)}px !important`
  },
  residentInfoBanner: {
    backgroundColor: `${theme.colorPalette.beige_40} !important`,
    boxShadow: 'none !important',
    padding: theme.spacing(4),
    margin: 0,
    minHeight: 'unset',
    display: 'flex',
    alignItems: 'center'
  }
});
